import { FC } from "react";
import { Container } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";

interface IExperience {
  role: string;
  company: string;
  period: string;
  bullets: string[];
}

const experiences: IExperience[] = [
  {
    role: "Full-Stack Developer",
    company: "BugRaid.AI",
    period: "Jul 2025 - Present",
    bullets: [
      "Built and enhanced both frontend UI and backend services, integrating monitoring/observability tools (Prometheus, Grafana, Jenkins) to improve system reliability and alerting.",
      "Worked on a Slack bot and Google Chat bot for automated incident alerts and RCA responses, plus scheduled on-call alert jobs.",
    ],
  },
  {
    role: "Full-Stack Developer",
    company: "Alazka.AI",
    period: "Feb 2023 - May 2025",
    bullets: [
      "Built a full-stack platform (React frontend + Node.js + PostgreSQL backend) enabling mass invoice uploads with automated data extraction, reducing manual processing by ~40%.",
      "Developed a customizable chatbot engine letting users upload their own data sources and embed bots into websites via iframe/script, delivering flexible automation tools for clients.",
    ],
  },
  {
    role: "Frontend Developer",
    company: "Gigahex",
    period: "Feb 2022 - Dec 2022",
    bullets: [
      "Designed and implemented reusable React components using UI libraries like Ant Design for efficient development.",
      "Managed application state using React's state management / Context API, ensuring smooth UI behavior.",
      "Integrated with backend APIs to fetch and manipulate data, enabling seamless frontend-backend communication.",
    ],
  },
];

const Experience: FC = () => {
  return (
    <Container id='experience'>
      <h2>Experience</h2>

      <div className='timeline'>
        {experiences.map((exp, i) => (
          <ScrollAnimation animateIn='fadeInUp' key={i}>
            <div className='exp-card'>
              <div className='exp-header'>
                <h3>
                  {exp.role} <span>@ {exp.company}</span>
                </h3>
                <span className='period'>{exp.period}</span>
              </div>
              <ul>
                {exp.bullets.map((bullet, j) => (
                  <li key={j}>{bullet}</li>
                ))}
              </ul>
            </div>
          </ScrollAnimation>
        ))}
      </div>

      <ScrollAnimation animateIn='fadeInUp'>
        <h2 className='education-title'>Education</h2>
        <div className='education'>
          <div className='exp-header'>
            <h3>
              Bachelor of Computer Applications <span>@ AISECT University, Jharkhand</span>
            </h3>
            <span className='period'>Sep 2019 - Oct 2022</span>
          </div>
        </div>
      </ScrollAnimation>
    </Container>
  );
};

export default Experience;
